import Axios from "axios";
import Host from "./host";
import Toast from 'vux/src/components/toast/index.vue'


const axios = Axios.create({
baseURL: Host.host,
timeout: 10000,
headers: {










}
});

axios.interceptors.request.use(
config => {


config.withCredentials = true

return config
},
error => {

console.log(error) 
return Promise.reject(error)
}
)

axios.interceptors.response.use(
response => {


if (response.status === 200) {
return Promise.resolve(response);
} else {
return Promise.reject(response);
}
},
error => {
if (error.response.status) {
switch (error.response.status) {

case 401:
Toast.show({
text: "请登录",
type: "text",
width: "80%",
isShowMask: true
});
break;
case 404:
Toast.show({
text: "网络请求不存在",
type: "text",
width: "80%",
isShowMask: true
});

break;
case 400:
Toast.show({
text: "服务器繁忙",
type: "text",
width: "80%",
isShowMask: true
});
break;
default:
Toast.show({
text: "网络延迟，请稍后再试",
type: "text",
width: "80%",
isShowMask: true
});
}
return Promise.reject(error.response);
}
}
);

/**
* @param {String} url [请求的url地址]
* @param {Object} params [请求时携带的参数]
*/

export function post(url, params = {}) {
params.token = sessionStorage.getItem("token");
return new Promise((resolve, reject) => {
axios
.post(url, params, { withCredentials: true })
.then(v => {
if (v.data.code == 200) {
resolve(v.data.data);
} else {
this.$toast(v.data.msg)
reject(v.data);
}
})
.catch(err => {
this.$toast('系统繁忙，请稍后再试!')
reject(err.data);
});
});
}



// WEBPACK FOOTER //
// ./src/Interface/axios.js